import { ReaderApp } from '@app/reader-app';

import { router } from './app.router';

import './app.css';

function App() {
	return <ReaderApp router={router} />;
}

export default App;
